import { COPY } from '../../data/copy';

const ITEMS = COPY.testimonials.items;

function Stars({ n }: { n: number }) {
  return (
    <div style={{ display: 'flex', gap: '2px' }} aria-label={`${n} estrelas`}>
      {Array.from({ length: n }).map((_, i) => (
        <svg key={i} width="14" height="14" viewBox="0 0 14 14" fill="#D4AF37" aria-hidden="true">
          <path d="M7 1l1.5 3.8L12.5 5l-2.9 2.6 1 4L7 9.7 3.4 11.6l1-4L1.5 5l4-.2z" />
        </svg>
      ))}
    </div>
  );
}

export function ResultadosReaisSection() {
  return (
    <section
      id="resultados"
      style={{
        padding: 'clamp(4rem, 8vw, 7rem) 2rem',
        background: 'radial-gradient(ellipse at 50% 50%, #1A0B2E 0%, #0A0416 65%)',
        borderTop: '1px solid rgba(212,175,55,0.1)',
      }}
    >
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <p style={{
          fontFamily: 'var(--font-body)',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '0.18em',
          textTransform: 'uppercase' as const,
          color: '#D4AF37',
          textAlign: 'center',
          marginBottom: '1.5rem',
        }}>
          {COPY.testimonials.eyebrow}
        </p>
        <h2 style={{
          textAlign: 'center',
          margin: '0 0 3.5rem',
          color: 'rgba(240,246,252,0.95)',
          fontFamily: 'var(--font-display)',
        }}>
          {COPY.testimonials.heading}
        </h2>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '1.5rem',
          }}
          className="resultados-grid"
        >
          {ITEMS.map((item, i) => (
            <div key={i} style={{
              background: '#0F0620',
              border: '1px solid rgba(212,175,55,0.15)',
              borderRadius: '16px',
              padding: '1.5rem',
              display: 'flex',
              flexDirection: 'column',
              gap: '0.75rem',
            }}>
              <Stars n={item.stars} />
              <p style={{
                fontFamily: 'var(--font-display)',
                fontSize: 'var(--text-15)',
                fontWeight: 300,
                color: 'rgba(200,220,235,0.8)',
                lineHeight: 1.65,
                margin: 0,
                flex: 1,
              }}>
                "{item.text}"
              </p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <p style={{
                    margin: 0,
                    fontFamily: 'var(--font-body)',
                    fontSize: 'var(--text-13)',
                    fontWeight: 600,
                    color: 'rgba(240,246,252,0.9)',
                  }}>
                    {item.name}
                  </p>
                  <p style={{
                    margin: 0,
                    fontFamily: 'var(--font-body)',
                    fontSize: 'var(--text-13)',
                    color: 'rgba(200,220,235,0.4)',
                  }}>
                    {item.location}
                  </p>
                </div>
                <span style={{
                  fontFamily: 'var(--font-body)',
                  fontSize: '11px',
                  fontWeight: 600,
                  letterSpacing: '0.1em',
                  textTransform: 'uppercase',
                  color: '#D4AF37',
                  background: 'rgba(212,175,55,0.1)',
                  border: '1px solid rgba(212,175,55,0.25)',
                  borderRadius: 'var(--radius-pill)',
                  padding: '0.2rem 0.6rem',
                }}>
                  {item.plan}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 1023px) {
          .resultados-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 639px) {
          .resultados-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
